export const washingHistory = {
  title: '洗浄履歴',
  laundrySuccess: '操作が完了しました。',
  laundryFail: 'エラーが発生しました。管理者に連絡してください。',
}
